import type { ListArtifactsResponse } from '@weave/schema-gen-ts/dist/schemas/integrations/sync-config-api/v1/message.pb';
import { ListArtifactsIO } from '../types';
import {
  UseSyncConfigV1InfiniteQueryEndpointArgs,
  useSyncConfigV1InfiniteQuery,
} from './use-sync-config-v1-infinite-query';

type ListArtifactsPageParam = string;
type ListArtifactsWireResponse = ListArtifactsResponse & {
  next_page_token?: string;
};

export const useListArtifactsQuery = <E = Error, D = ListArtifactsIO['output']>({
  options,
  request,
  ...args
}: UseSyncConfigV1InfiniteQueryEndpointArgs<'ListArtifacts', E, D, ListArtifactsPageParam>) =>
  useSyncConfigV1InfiniteQuery<'ListArtifacts', E, D, ListArtifactsPageParam>({
    endpointName: 'ListArtifacts',
    ...args,
    request: ({ pageParam }) => ({
      ...request,
      pageToken: pageParam ?? request.pageToken,
    }),
    options: {
      ...options,
      getNextPageParam: (lastPage) => {
        const response = lastPage as ListArtifactsWireResponse;
        const nextPageToken = response.nextPageToken ?? response.next_page_token;

        return nextPageToken || undefined;
      },
    },
  });
